import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'compact';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-display font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,background-image,box-shadow,color,border-color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-rose-300 active:translate-y-px';
const sizes: Record<NonNullable<CtaButtonProps['size']>, string> = {
  sm: 'px-4 py-2.5 text-xs',
  md: 'px-6 py-3.5 text-sm',
  lg: 'px-8 py-4 text-base md:text-lg',
  xl: 'px-8 py-5 text-lg md:text-2xl'
};
const variants: Record<NonNullable<CtaButtonProps['variant']>, string> = {
  primary: 'bg-rose-500 bg-[linear-gradient(135deg,#db2777_0%,#e91e63_100%)] text-white shadow-cta hover:bg-plum-700 hover:bg-[linear-gradient(135deg,#a3134d_0%,#831843_100%)]',
  secondary: 'border-2 border-rose-500 bg-transparent text-rose-600 hover:border-plum-700 hover:text-plum-700',
  compact: 'bg-rose-500 text-white hover:bg-plum-700'
};
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#inversion',
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-43" data-mp="3owa0m98c1tna">
      <span data-id="element-44" data-mp="3sxlskleoiqyn">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-45" data-mp="3swu21ozxvjf8" />
    </a>;
}